import { HTMLAttributes, memo } from 'react';
import styled from '@emotion/styled';
import LogisticsList from './LogisticsList';
import { LogisticsPackage } from './useTradeTranslate';
import TradeDetailNoData from './TradeDetailNoData';
import MercadoLogistics from './MercadoLogistics';

export const LogisticsContent = styled(LogisticsList)`
  overflow: hidden;
  > div {
    margin-bottom: 4px;
    border-bottom: none;
    border: 1px solid #f0f2f5;
  }

  section {
    background: #f7f9fa;
  }
`;

export interface TradeDetailLogisticsProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.TradeWithLogistics;
  exportMode?: boolean;
}

function TradeDetailLogistics(props: TradeDetailLogisticsProps) {
  const { trade, exportMode = false } = props;
  const { logisticsList: tradeLogisticsList, lazadaLogistics, mercadoLogistics } = trade;

  if (tradeLogisticsList && tradeLogisticsList.length > 0) {
    const [{ leChatStatus }] = tradeLogisticsList;

    let logisticsList: undefined | LogisticsPackage<'SHOPEE'>[];

    if (leChatStatus !== undefined) {
      logisticsList = tradeLogisticsList;
    }

    const logisticsInfo =
      logisticsList && logisticsList.length > 0 ? (
        <>
          <LogisticsContent
            sendable={false}
            exportMode={exportMode}
            platform="SHOPEE"
            logisticsPackageList={logisticsList}
            fold
            foldNum={2}
            showCopyAll={false}
          />
        </>
      ) : (
        <TradeDetailNoData />
      );

    return logisticsInfo;
  }

  if (lazadaLogistics) {
    const { packages } = lazadaLogistics;

    if (packages && packages.length > 0) {
      const logisticsList = packages;

      const logisticsInfo =
        logisticsList && logisticsList.length > 0 ? (
          <>
            <LogisticsContent
              sendable={false}
              platform="LAZADA"
              logisticsPackageList={logisticsList}
              fold
              foldNum={2}
              showCopyAll={false}
            />
          </>
        ) : (
          <TradeDetailNoData />
        );

      return logisticsInfo;
    }
  }

  if (mercadoLogistics) {
    return <MercadoLogistics isDetail logistics={mercadoLogistics} />;
  }

  return <TradeDetailNoData />;
}

export default memo(TradeDetailLogistics);
